module.exports = __webpack_public_path__ + "img/05.648dec8e.png";